import React, { Component } from 'react'
import { getCookie } from '../../utils/CookieHelper';
import Service from '../../config/networkutils'
import { Box, CircularProgress } from '@material-ui/core';
import ReactApexChart from 'react-apexcharts';
import { withSnackbar } from 'notistack';
import { getDataIsdeletedFalse } from '../Helper/CommonThings';

const token = getCookie("ptd_ts_token");
class SubContractorsGraph extends Component {
    constructor(props) {
        super()
        this.state = {
            isLoading: true,
            series: [],
            options: {
                chart: {
                    height: 350,
                    type: 'bar',
                    parentHeightOffset: 0,
                    events: {
                        click: function (event, chartContext, opts) {
                            console.log(event, chartContext, opts)
                        }
                    }
                },
                // colors: ['#3399ff', '#ff9933', '#808080', '#ffd11a'],
                plotOptions: {
                    bar: {
                        columnWidth: '45%',
                        distributed: true,
                    }
                },
                title: {
                    text: 'External on site current week',
                    align: 'center',
                },
                grid: {
                    padding: {
                        bottom: 0
                    }
                },
                legend: {
                    show: true
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    title: 'None Working Daily Update',
                    categories: [],
                    labels: {
                        style: {
                            fontSize: '12px'
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        this.getData()
    }

    getData() {
        Service.get(`/api/subcontractor/other_report_subcontractor_capacity/?category=${this.props.gang.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let data = []
                let categories = []
                let resData = getDataIsdeletedFalse(res.data)
                for (let index = 0; index < resData.length; index++) {
                    const element = resData[index];
                    categories.push(element.project_code ? element.project_code : element.project_name)
                    data.push(element.subcontractor_count)
                }
                let series = [{
                    name: 'External',
                    data: data
                }]
                this.setState({ series: series, options: { ...this.state.options, xaxis: { ...this.state.options.xaxis, categories: categories }, }, isLoading: false });
            })
            .catch(error => {
                console.log(error);
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    render() {
        return (
            <div>{this.state.isLoading ?
                <Box display="flex" justifyContent="center" alignItems="center"><CircularProgress /></Box> :
                <ReactApexChart options={this.state.options} series={this.state.series} width={'100%'} type="bar" height={window.innerHeight / 2 - 50} />}
            </div>
        )
    }
}

export default withSnackbar(SubContractorsGraph);
